import { useState } from "react";
import { useTranslation } from "react-i18next";
import { PlusIcon } from "../../../../components/restaurant-schema/schemaIcons";
import { Field, TextField } from "./formControls";
import { GhostButton, PrimaryButton, SchemaModalShell } from "./SchemaModalShell";

/** „Нов регион": само името — същото поле като в настройките. */
const RegionCreateModal = ({
  open,
  onSubmit,
  onClose,
}: {
  open: boolean;
  onSubmit: (name: string) => Promise<void>;
  onClose: () => void;
}) => {
  const { t } = useTranslation();
  const [name, setName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const canSave = name.trim().length > 0;

  const handleSave = async () => {
    if (!canSave || isSubmitting) return;
    setIsSubmitting(true);
    try {
      await onSubmit(name.trim());
    } catch {
      // Грешката е показана от родителя.
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <SchemaModalShell
      open={open}
      size="form"
      icon={<PlusIcon className="h-5 w-5" />}
      title={t("restaurantSchema.regionCreate.title")}
      subtitle={t("restaurantSchema.regionCreate.subtitle")}
      onClose={onClose}
      footer={
        <>
          <GhostButton onClick={onClose} disabled={isSubmitting}>
            {t("common.cancel")}
          </GhostButton>
          <PrimaryButton onClick={handleSave} disabled={!canSave} loading={isSubmitting}>
            {t("restaurantSchema.regionCreate.submit")}
          </PrimaryButton>
        </>
      }
    >
      <Field label={t("restaurantSchema.region.name")} required>
        <TextField
          value={name}
          onChange={setName}
          onEnter={handleSave}
          placeholder={t("restaurantSchema.region.namePlaceholder")}
          maxLength={60}
          autoFocus
        />
      </Field>
    </SchemaModalShell>
  );
};

export default RegionCreateModal;
